import { render } from "./SkeletonImage.vue?vue&type=template&id=810b3720"
import script from "./SkeletonImage.vue?vue&type=script&lang=js"
export * from "./SkeletonImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__